import { HOST } from "consts"
import { sendRequest } from "./Main"


export const OpenChatRoom = async (data: any) => {
    const endpoint = HOST + "/api/Chat/OpenChatRoom/"
    const method = "POST"
    return await sendRequest(endpoint, method, data)
}